import type { FunctionComponent, PropsWithChildren } from 'react';
import TransitionRoute from './TransitionRoute';
import type { Props as TransitionRouteProps } from './TransitionRoute';
import { DIALOG_CLASSNAME, DIALOG_TIMEOUT } from './animation';

type Props = Omit<TransitionRouteProps, 'classNames' | 'timeout'>;

const DialogTransitionRoute: FunctionComponent<Props> = (
	props: PropsWithChildren<Props>
) => {
	return (
		<TransitionRoute
			{...props}
			classNames={DIALOG_CLASSNAME}
			timeout={DIALOG_TIMEOUT}
		/>
	);
};

export default DialogTransitionRoute;
